<div class="container-fluid tw-bg-gradient-to-b tw-from-[#1a1a2e] tw-to-[#16213e] tw-pb-12">
    <!-- Encabezado -->
    <div class="tw-max-w-5xl tw-mx-auto tw-px-4">
      <h2 class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight">
        <span class="tw-text-white">
          Feedback Onelink
        </span>
      </h2>
      
      <div class="tw-h-1 tw-bg-gradient-to-r tw-from-transparent tw-via-[#F67011] tw-to-transparent tw-w-3/4 tw-mx-auto tw-my-4"></div>
      
      <div class="tw-max-w-7xl tw-mx-auto tw-px-4 tw-py-2">
        <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 lg:tw-grid-cols-3 tw-gap-6 tw-mt-4">
          <app-review/>
          <app-review/>
          <app-review/>

        </div>
      </div>
    </div>
   
  
  
  </div>